export default __webpack_public_path__ + "96eaf0e200253d9cfc04e3eb8fa32ffc.svg";